export { ModalDispatchProvider } from './config/modal-dispatch-provider'

export { useModalDispatch } from './hooks/use-modal-dispatch'

export { type DispatchedModalProps } from './config/types'
